import React from 'react';
import Button from './Button';
import FadeIn from './FadeIn';
import SafeIcon from '../common/SafeIcon';
import { FiArrowRight, FiPlayCircle } from 'react-icons/fi';

export default function Hero() {
  const handlePurchase = () => {
    window.location.href = 'https://coassemble.com/learn/IXKIQH';
  };

  return (
    <section className="pt-12 pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div className="text-left">
          <FadeIn>
            <span className="inline-flex items-center py-1 px-3 rounded-full bg-blue-100 text-blue-800 text-sm font-medium mb-6">
              <SafeIcon icon={FiPlayCircle} className="mr-2" /> Digital Video Course • Instant Access
            </span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 tracking-tight mb-6 leading-tight">
              Stop the Money Panic. <br />
              <span className="text-blue-600">Regain Control in 7 Days.</span>
            </h1>
          </FadeIn>
          
          <FadeIn delay={0.1}>
            <p className="text-lg sm:text-xl text-slate-600 mb-10 max-w-xl leading-relaxed">
              A calm, step-by-step system to end overdrafts, organize your bills, and finally breathe easier on payday—without complicated spreadsheets.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} className="flex flex-col sm:items-start items-center">
            <Button onClick={handlePurchase} className="mb-4">
              Start My 7-Day Reset
              <SafeIcon icon={FiArrowRight} className="ml-2" />
            </Button>
            <p className="text-sm text-slate-500 font-medium italic">Just $1.98 • Less than one overdraft fee</p>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} className="relative">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-video lg:aspect-square">
            <img 
              src="https://images.unsplash.com/photo-1518063319789-7217e6706b04?auto=format&fit=crop&q=80&w=1200" 
              alt="Calm morning with coffee and notebook" 
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-blue-900/10 mix-blend-multiply"></div>
          </div>
          
          <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-lg hidden sm:block border border-slate-100">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center">
                <SafeIcon icon={FiPlayCircle} className="text-emerald-600 text-xl" />
              </div>
              <div>
                <p className="text-xs text-slate-500 font-medium">Inside the course</p>
                <p className="text-sm font-bold text-slate-900">7 Actionable Lessons</p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}